<template>
  <div>
    <v-dialog v-model="showForm" fullscreen>
      <laboral-request-form
        v-if="showForm"
        v-model="formData"
        :codempre="codempre"
        :disabled="readOnly"
        @submit="submit()"
        @close-form="closeForm()"
      ></laboral-request-form>
    </v-dialog>
    <v-dialog v-model="showWorkerDetails" fullscreen>
      <worker-details-form
        v-if="showWorkerDetails"
        v-model="workerDetails"
        :admin-view="adminView"
        :disabled="true"
        @close-form="closeWorkerDetails()"
      ></worker-details-form>
    </v-dialog>
    <v-layout>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout v-if="adminView" wrap>
      <v-flex xs4>
        <v-select
          solo
          color="primary"
          v-model="filters.show_my_customers"
          item-text="text"
          item-value="value"
          :items="[
            { text: 'No filtrar', value: false },
            { text: 'Sólo mis clientes', value: true },
          ]"
          row
        ></v-select>
      </v-flex>
    </v-layout>
    <v-tabs v-model="activeTab">
      <v-tab>En alta</v-tab>
      <v-tab>Histórico</v-tab>
      <v-tab>Todos los contratos</v-tab>
      <v-tab-item v-model="activeTab">
        <workers-table
          :entities="entities"
          :pagination.sync="pagination"
          :loading="loading"
          :admin-view="adminView"
          :active-or-inactive="activeOrInactive"
          @alta-trabajador-clicked="altaTrabajadorClicked"
          @baja-trabajador-clicked="bajaTrabajadorClicked"
          @modifica-contrato-clicked="modificaContratoClicked"
          @otras-acciones-clicked="otrasAccionesClicked"
          @show-item-clicked="showItemClicked"
        ></workers-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import WorkersTable from './tables/WorkerTable.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import LaboralRequestForm from '../components/forms/laboral-requests/LaboralRequestForm.vue';
import WorkerDetailsForm from '../components/forms/worker-details/WorkerDetailsForm.vue';

export default {
  name: 'Workers',
  components: { WorkersTable, LaboralRequestForm, WorkerDetailsForm },
  props: {
    codempre: {
      type: [String, Number],
    },
    adminView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      activeTab: 0,
      showForm: false,
      showWorkerDetails: false,
      readOnly: false,

      workerDetails: {
        fullname: null,
        nif: null,
        num_ss: null,
        birthdate: null,
        address: null,
        city: null,
        province: null,
        cp: null,
        nationality: null,
        phone: null,
        email: null,
      },

      formData: {
        comments: '',
        status: null,
        type: null,
        codempre: null,
        date: null,
        worker_data: {
          fullname: null,
          nif: null,
          num_ss: null,
          birthdate: null,
          address: null,
          city: null,
          province: null,
          cp: null,
          nationality: null,
          phone: null,
          email: null,
        },
        request_data: {},
      },
      entities: [],
      search: '',
      filters: {
        // type: null,
        // date: null,
        // status: null,
        // codempre: null,
        // readed: null,
        show_my_customers: this.adminView,
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
    };
  },
  mounted() {
    this.getEntities();
  },
  computed: {
    activeOrInactive() {
      if (this.activeTab === 0) {
        return 'active';
      }
      if (this.activeTab === 1) {
        return 'inactive';
      }
      if (this.activeTab === 2) {
        return 'all';
      }

      return 'active';
    },
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
    sortBy() {
      return this.pagination.sortBy;
    },
    descending() {
      return this.pagination.descending;
    },
    filterStr() {
      return [
        // this.filters.type,
        // this.filters.status,
        // this.filters.codempre,
        // this.filters.date,
        // this.filters.readed,
        this.filters.show_my_customers,
      ].join('-');
    },
  },
  methods: {
    getChangeStr() {
      return [
        this.pagination.descending,
        this.pagination.page,
        this.pagination.rowsPerPage,
        this.pagination.sortBy,
        this.pagination.totalItems,
        this.search,
        this.codempre,
        this.activeOrInactive,
        this.filterStr,
      ].join('-');
    },
    restartWorkerDetails() {
      this.workerDetails = {};
    },
    restartFormData() {
      this.formData = {
        comments: '',
        status: null,
        type: null,
        codempre: null,
        date: null,
        worker_data: {
          fullname: null,
          nif: null,
          num_ss: null,
          birthdate: null,
          address: null,
          city: null,
          province: null,
          cp: null,
          nationality: null,
          phone: null,
          email: null,
        },
        request_data: {},
      };
    },
    async getEntities() {
      this.loading = true;

      const params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
      };

      if (this.pagination.sortBy) {
        params['sort_by'] = this.pagination.sortBy;
      }
      if (this.pagination.descending) {
        params['descending'] = this.pagination.descending;
      }
      if (this.search) {
        params['custom_search'] = this.search;
      }

      if (this.codempre) {
        params['CODEMPRE'] = this.codempre;
      }

      Object.keys(this.filters).forEach(filterKey => {
        if (this.filters[filterKey]) {
          params[filterKey] = this.filters[filterKey];
        }
      });

      params['status'] = this.activeOrInactive;

      const res = await apiCtrl.get('/workers', { params: params });

      this.pagination = {
        descending: this.pagination.descending,
        page: res.data.meta.current_page,
        rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
        sortBy: this.pagination.sortBy,
        totalItems: Number(res.data.meta.total),
      };

      this.entities = res.data.data;
      this.loading = false;
    },

    async getEntitiesIfStopChanging() {
      const initialStr = this.getChangeStr();

      setTimeout(() => {
        const compareStr = this.getChangeStr();
        if (initialStr === compareStr) {
          this.getEntities();
        }
      }, 300);
    },

    closeForm() {
      console.log('Close Form from page');
      this.showForm = false;
      this.readOnly = false;
    },
    closeWorkerDetails() {
      console.log('Close closeWorkerDetails from page');
      this.showWorkerDetails = false;
    },
    submit() {
      if (this.formData.id) {
        this.updateEntity();
      } else {
        this.saveEntity();
      }
    },

    saveEntity() {
      this.savingData = true;
      apiCtrl
        .post('/laboral-requests', this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
          this.$emit('entity-saved', this.formData);
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },
    updateEntity() {
      this.savingData = true;
      apiCtrl
        .put('/laboral-requests/' + this.formData.id, this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
          this.$emit('entity-saved', this.formData);
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },

    altaTrabajadorClicked(worker) {
      this.restartFormData();
      this.formData.worker_data = this.workerToWorkerData(worker);
      this.formData.type = 'alta_trabajador';
      this.readOnly = false;
      this.showForm = true;
    },
    bajaTrabajadorClicked(worker) {
      this.restartFormData();
      this.formData.worker_data = this.workerToWorkerData(worker);
      this.formData.type = 'baja_trabajador';
      this.readOnly = false;
      this.showForm = true;
    },
    modificaContratoClicked(worker) {
      this.restartFormData();
      this.formData.worker_data = this.workerToWorkerData(worker);
      this.formData.type = 'modificacion_contrato';
      this.readOnly = false;
      this.showForm = true;
    },
    otrasAccionesClicked(worker) {
      this.restartFormData();
      this.formData.worker_data = this.workerToWorkerData(worker);
      this.formData.type = 'otras';
      this.readOnly = false;
      this.showForm = true;
    },
    showItemClicked(worker) {
      this.restartWorkerDetails();
      const someWorkerDetails = this.workerToWorkerData(worker);

      this.workerDetails = {
        ...worker,
        ...someWorkerDetails,
      };

      // add extra params here
      // ...

      this.showWorkerDetails = true;
    },
    workerToWorkerData(worker) {
      const workerData = {
        fullname: worker.fullname,
        nif: worker.NIF,
        num_ss: worker.NUM_AFILIACION,
        birthdate: worker.FEC_NACI,
        address: worker.address,
        city: worker.city,
        province: worker.province,
        cp: worker.CODPOS,
        nationality: worker.nationality,
        phone: worker.TELEF1 || worker.TELEF2,
        email: worker.EMAIL,
      };

      return workerData;
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterStr: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getEntitiesIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    sortBy: function() {
      this.getEntitiesIfStopChanging();
    },
    descending: function() {
      this.getEntitiesIfStopChanging();
    },
    activeOrInactive: function() {
      this.getEntitiesIfStopChanging();
    },
  },
};
</script>

<style></style>
